<template>
    <span>
        <b-icon v-if="showGps && label" icon="circle-fill" :class="this.sizeClass" class="mb-0"
            :variant="gpsVariant(this.gpsTimestamp)" :title="gpsIconTitle(this.gpsTimestamp)">
        </b-icon>
        
       
    
        <!-- A few icons which have been tested for call icons telephone-fill file-earmark-plus folder-plus node-plus patch-plus person-plus plus-square shield-plus-->

        {{&nbsp;}}
        <br v-if="verticalLayout && (showLabel || showLink) && showGps && label">
        <router-link v-if="showLink && showLabel && label" :to="{ path: this.linkPath, query: this.linkQueryComp }">{{this.label}}</router-link>
        <span v-else-if="!showLink && showLabel && label">{{this.label}}</span>
        {{&nbsp;}}
        <span :class="callCss" v-if="addGroupCall && sipClientId" @click="addToGroupCall">
            <b-icon icon="telephone-plus" :class="'mb-0 ' + sizeClass" v-b-tooltip.hover :title="$t('voip.group_call.add')"/>
        </span>
        <span :class="callCss" v-if="removeGroupCall && sipClientId" @click="removeFromGroupCall">
            <b-icon icon="telephone-minus" :class="'mb-0 ' + sizeClass" v-b-tooltip.hover :title="$t('voip.group_call.remove')"/>
        </span>
        <span :class="individualCallClass" v-if="showIndividualCall && sipClientId" @click="makeIndividualCall">
            <b-icon icon="telephone-fill" :class="'mb-0 ' + sizeClass" v-b-tooltip.hover :title="!isCallInProgress && isPhoneOnline ? $t('voip.phone.make_individual_call') : ''"/>
        </span>
        <router-link :to="mapButtonClickable ? { path: '/map/mapview', query: { vehicleLabel: this.label } } : { }">
            <span :class="vehicleOnMapClass" v-if="showVehicleOnMap" >
                <b-icon icon="geo-alt" :class="'mb-0 ' + sizeClass" v-b-tooltip.hover/>
                <b-icon icon="geo-alt-fill" :class="'mb-0 ' + sizeClass" v-b-tooltip.hover/>
            </span>
        </router-link>
    </span>

</template>

<script>
import moment from 'moment';
import vehicleReport from '@/store/realtime/vehicleReport'
import realtime from '@/store/realtime/realtime'
import phone from '@/store/dispatching/phone'

export default {
    name: 'VehicleBrief',
    props: {
        label: {
            type: String
        },
        linkPath: {
            type: String,
            default: '/reports/vehiclehistory'
        },
        linkQuery: {
            type: Object
        },
        showGps: {
            type: Boolean,
            default: true
        },
        showLabel: {
            type: Boolean,
            default: true
        },
        showLink: {
            type: Boolean,
            default: true
        },
        verticalLayout: {
            type: Boolean,
            default: false
        }, 
        sizeClass: {
            type: String,
            default: 'h5'
        },
        showIndividualCall: {
            type: Boolean,
            default: false
        },
        showVehicleOnMap: {
            type: Boolean,
            default: false
        },
        addGroupCall: {
            type: Boolean,
            default: false
        },
        removeGroupCall: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            mapButtonClickable: false
        }
    },
    computed: {
        linkQueryComp() {
            return this.linkQuery == null ? {id: this.label} : this.linkQuery;
        },
        gpsTimestamp() {
            let vehicle = this.$store.state.vehicleReport.vehicleReportList.find(v => v.vehicleLabel == this.label);
            if (vehicle)
                return vehicle.gpsTimestamp;
            return null;
        },
        sipClientId() {
            return this.$store.getters['realtime/getVehicleByLabel'](this.label)?.features['SIP_CLIENT_ID'];
        },
        callStatus() {
            return this.$store.state.phone.phoneState.status;
        },
        callCss() {
            if (this.isCallInProgress)
                return 'call disabled';
            return 'call';
        },
        individualCallClass() {
            if (this.isCallInProgress || !this.isPhoneOnline) {
                return 'call disabled';
            }
            return 'call';
        },
        isCallInProgress() {
            return this.callStatus == 'calling' || this.callStatus == 'call_connected'
        },
        isPhoneOnline() {
            const sipClient = this.$store.state.phone.phonebook[this.sipClientId];
            return sipClient && sipClient.status == 'online'  
        },
        vehicleOnMapClass() {
            const vehicle = this.$store.state.vehicleReport.vehicleReportList.find(v => v.vehicleLabel == this.label);
            if(vehicle && vehicle.gpsTimestamp) {
                this.setMapButtonClickable(true)
                return 'linkToMap'
            }
            this.setMapButtonClickable(false)
            return 'linkToMap disabled'
        }
    },
    beforeCreate: function() {
        if (!this.$store.state.realtime) {
            this.$store.registerModule('realtime', realtime);
        }
         if (!this.$store.state.phone) {
            this.$store.registerModule('phone', phone);
        }
        this.$store.dispatch('realtime/getVehicles');
    },
    created(){
        if(this.showGps){
            if (!this.$store.state.vehicleReport) {
                this.$store.registerModule('vehicleReport', vehicleReport);
            }
            this.updateData();
        }
    },
    beforeDestroy(){
        if(this.dataUpdater != null)
            clearTimeout(this.dataUpdater);
    },
    methods: {
        makeIndividualCall() {
            if (!this.isCallInProgress && this.isPhoneOnline)
                this.$store.commit('phone/requestIndividualCall', this.sipClientId);
        },
        setMapButtonClickable(value) {
            this.mapButtonClickable = value
        },
        addToGroupCall() {
            if (!this.isCallInProgress)
                this.$store.commit('phone/addGroupCallRecipient', this.sipClientId);
        },
        removeFromGroupCall() {
            if (!this.isCallInProgress)
                this.$store.commit('phone/removeGroupCallRecipient', this.sipClientId);
        },
        gpsVariant(gpsTimestamp) {
            if (!gpsTimestamp) {
                return 'dark';
            }
            let gpsTime = new moment(gpsTimestamp, 'YYYY-MM-DD[T]HH:mm:ssZZ');
            let compTime = new moment();
            if (gpsTime.isBefore(compTime.subtract(3, 'minutes'))) {
                return 'danger';
            }
            if (gpsTime.isBefore(compTime.add(2, 'minutes'))) {
                return 'warning';
            }
            return 'success';
        },
        gpsIconTitle(gpsTimestamp) {
            if (gpsTimestamp) {
				let text = this.$t('vehicle_report.info_messages.' + this.gpsVariant(gpsTimestamp));
                return new moment(gpsTimestamp, 'YYYY-MM-DD[T]HH:mm:ssZZ').format('DD.MM.YYYY HH:mm:ss') + '\n' + text;
            }
            return this.$t('vehicle_report.info_messages.no_gps');
        },
        updateData() {
			this.$store.dispatch('vehicleReport/getVehicleReportList');

			this.dataUpdater = setTimeout(this.updateData, 30 * 1000)
		}
    }
}
</script>

<style lang="scss">
.call {
    margin-right: 6px;
    color: green;
}
.call.disabled {
    color: grey;
}
.linkToMap {
    color: green;
}
.linkToMap.disabled {
    color: grey;
}

.linkToMap svg:nth-child(2) {
  display: none; 
}

.linkToMap:hover svg:nth-child(2) {
  display: inline;
}

.linkToMap:hover svg:nth-child(1) {
  display: none;
}

.linkToMap.disabled svg:nth-child(1) {
    display: inline;
}
.linkToMap.disabled svg:nth-child(2) {
    display: none;
}
</style>